  
function getSafra3(){
    var $select = $('#selecsafra3');
    var safra = $select.val();

    return safra;
}

function montaGrafDespesasComp(ling){

    var safra = getSafra3();
    var etapasplan = ['preplantioplan', 'plantioplan', 'colheitaplan', 'manutencaosafraplan', 'armazenamentosafraplan', 'comercializacaoplan', 'logrecinsumoplan', 'logentregaarmazplan', 'entregasafracomercplan']
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']


    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            mes = json.map(function(item) {
                return item.mes;
            });

            ano = json.map(function(item) {
                return item.ano;
            });

            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            console.log(tipoetapa);
            console.log(fluxo);
            console.log(valor);

            var ctx = document.getElementById('grafdespcomp').getContext('2d');

            var mapaplan = new Map();
            var mapaexec = new Map();

            var tamanho = tipoetapa.length;

            for(i=0; i<tamanho; i++){
                if(fluxo[i] === 'receita') continue;

                var label = mes[i] + '/' + ano[i];
                var val = valor[i];


                if(etapasplan.indexOf(tipoetapa[i])>-1){
                    if(mapaplan.has(label)===true){
                        var temp = mapaplan.get(label) + val;
                        mapaplan.set(label, temp);
                    }
                    else{
                        mapaplan.set(label, val);
                    }
                }
                else{
                    if(mapaexec.has(label)===true){
                        var temp = mapaexec.get(label) + val;
                        mapaexec.set(label, temp);
                    }
                    else{
                        mapaexec.set(label, val);
                    }
                }
            }

            var mapeamentogeral = new Map();
            
            var kv;
            for (  kv in mapaplan.entries()) {
                key = kv[0];
                value = kv[1];

                if(mapaexec.has(key)){
                    mapeamentogeral.set(key, [value, mapaexec.get(key)]);
                }
                else{
                    mapeamentogeral.set(key, [value, 0]);
                }
            }

            var kv;
            for ( kv in mapaexec.entries()) {
                key = kv[0];
                value = kv[1];

                if(mapeamentogeral.has(key) == false){
                    mapeamentogeral.set(key, [0, value]);
                }
            }


            var vlabels=[]; var vdataplan =[]; var vdataexec=[];
            for ( kv in mapeamentogeral.entries()) {
                key = kv[0];
                value = kv[1];
                
                vlabels.push(key);
                vdataplan.push(value[0]);
                vdataexec.push(value[1]);
                console.log(key + " = " + value);
            }

            var labelValorPlan; var labelValorExec; var labelTexto;
            if(ling === "pt"){
                labelValorPlan = "Valor planejado";
                labelValorExec = "Valor executado";
                labelTexto = "Comparativo de Despesas";
            }
            else if(ling === "es"){
                labelValorPlan = "Planificado";
                labelValorExec = "Ejecutado";
                labelTexto = "Comparativo de Gastos";
            }
            else{
                labelValorPlan = "Planned value";
                labelValorExec = "Executed value";
                labelTexto = "Output Comparative";
            } 

            var myLineChart = new Chart(ctx, {
                type: 'line',
                data: {
                labels: vlabels,
                datasets: [{ 
                    data: vdataplan,
                    label: labelValorPlan,
                    borderColor: "#ff0000",
                    fill: true
                    }
                    ,
                    { 
                        data: vdataexec,
                        label: labelValorExec,
                        borderColor: "#00ff00",
                        fill: true
                }
                ]
                },
                options: {
                title: {
                    display: true,
                    text: labelTexto
                }
                }
            });
        }
    });
   
}

function montaGrafReceitasComp(ling){

   
    var safra = getSafra3();
    var etapasplan = ['preplantioplan', 'plantioplan', 'colheitaplan', 'manutencaosafraplan', 'armazenamentosafraplan', 'comercializacaoplan', 'logrecinsumoplan', 'logentregaarmazplan', 'entregasafracomercplan']
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']


    console.log("Inicio");
    
    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            mes = json.map(function(item) {
                return item.mes;
            });

            ano = json.map(function(item) {
                return item.ano;
            });

            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            console.log(tipoetapa);
            console.log(fluxo);
            console.log(valor);

            var ctx = document.getElementById('grafreccomp').getContext('2d');

            var mapaplan = new Map();
            var mapaexec = new Map();

            var tamanho = tipoetapa.length;

            for(i=0; i<tamanho; i++){
                if(fluxo[i] === 'despesa') continue;

                var label = mes[i] + '/' + ano[i];
                var val = valor[i];


                if(etapasplan.indexOf(tipoetapa[i])>-1){
                    if(mapaplan.has(label)===true){
                        var temp = mapaplan.get(label) + val;
                        mapaplan.set(label, temp);
                    }
                    else{
                        mapaplan.set(label, val);
                    }
                }
                else{
                    if(mapaexec.has(label)===true){
                        var temp = mapaexec.get(label) + val;
                        mapaexec.set(label, temp);
                    }
                    else{
                        mapaexec.set(label, val);
                    }
                }
            }

            var mapeamentogeral = new Map();
            for ( kv in mapaplan.entries()) {
                key = kv[0];
                value = kv[1];

                if(mapaexec.has(key)){
                    mapeamentogeral.set(key, [value, mapaexec.get(key)]);
                }
                else{
                    mapeamentogeral.set(key, [value, 0]);
                }
            }

            for ( kv in mapaexec.entries()) {
                key = kv[0];
                value = kv[1];

                if(mapeamentogeral.has(key) == false){
                    mapeamentogeral.set(key, [0, value]);
                }
            }


            var vlabels=[]; var vdataplan =[]; var vdataexec=[];
            for ( kv in mapeamentogeral.entries()) {
                key = kv[0];
                value = kv[1];

                vlabels.push(key);
                vdataplan.push(value[0]);
                vdataexec.push(value[1]);
                console.log(key + " = " + value);
            }

            var labelValorPlan; var labelValorExec; var labelTexto;
            if(ling === "pt"){
                labelValorPlan = "Valor planejado";
                labelValorExec = "Valor executado";
                labelTexto = "Comparativo de Receita";
            }
            else if(ling === "es"){
                labelValorPlan = "Planificado";
                labelValorExec = "Ejecutado";
                labelTexto = "Comparativo de Rendimiento";
            }
            else{
                labelValorPlan = "Planned value";
                labelValorExec = "Executed value";
                labelTexto = "Income Comparative";
            } 

            var myLineChart = new Chart(ctx, {
                type: 'line',
                data: {
                labels: vlabels,
                datasets: [{ 
                    data: vdataplan,
                    label: labelValorPlan,
                    borderColor: "#ff0000",
                    fill: true
                    }
                    ,
                    { 
                        data: vdataexec,
                        label: labelValorExec,
                        borderColor: "#00ff00",
                        fill: true
                }
                ]
                },
                options: {
                title: {
                    display: true,
                    text: labelTexto
                }
                }
            });
            
        }
    });
}

function montaGrafDespesasEtapasComp(ling){
    var safra = getSafra3();
    var etapasplan = ['preplantioplan', 'plantioplan', 'colheitaplan', 'manutencaosafraplan', 'armazenamentosafraplan', 'comercializacaoplan', 'logrecinsumoplan', 'logentregaarmazplan', 'entregasafracomercplan']
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']


    console.log("Inicio");

    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            var vdatasplan = [0, 0, 0, 0, 0, 0, 0, 0, 0];
            var vdatasexec = [0, 0, 0, 0, 0, 0, 0, 0, 0];

            var tamanho = tipoetapa.length;

            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'receita') continue;
                if(etapasplan.indexOf(tipoetapa[i])==-1) continue;

                vdatasplan[etapasplan.indexOf(tipoetapa[i])] += valor[i];
            }


            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'receita') continue;
                if(etapas.indexOf(tipoetapa[i])==-1) continue;

                vdatasexec[etapas.indexOf(tipoetapa[i])] += valor[i];
            }

            var ctx = document.getElementById('grafdespetapacomp').getContext('2d');        

            var vlabels; var labelValorPlan; var labelValorExec; var labelTexto; var labelEtapa; var labelValor;
            if(ling === "pt"){
                labelValorPlan = "Valor planejado";
                labelValorExec = "Valor executado";
                labelTexto = "Comparativo de Despesas Por Etapa";
                vlabels = ['Pré-plantio', 'Plantio', 'Colheita', 'Manutenção', 'Armazenamento', 'Comercialização', 'Recebimento de Insumos', 'Entrega para Armazenamento', 'Entrega Para Comercialização'];
                labelEtapa = "Etapa";
                labelValor = "Valor";
            }
            else if(ling === "es"){
                labelValorPlan = "Planificado";
                labelValorExec = "Ejecutado";
                labelTexto = "Comparativo de Gastos Por Etapa";
                vlabels = ['Pre-siembra', 'Siembra', 'Vendimia', 'Mantenimiento', 'Almacenamiento', 'Comercialización', 'Recebimiento de Consumiveis', 'Entrega para el Almacenamiento', 'Entrega para la Comercialización'];
                labelEtapa = "Etapa";
                labelValor = "Valor";
            }
            else{
                labelValorPlan = "Planned value";
                labelValorExec = "Executed value";
                labelTexto = "Output Comparative By Stage";
                vlabels = ['Pre-planting', 'Planting', 'Ingathering', 'Maintenance', 'Storage', 'Commercialization', 'Inputs Receiving', 'Delivery for Storage', 'Delivery for Commercialization'];
                labelEtapa = "Stage";
                labelValor = "Value";
            } 

            var chart = new Chart(ctx, {
                type: 'bar',

                data: {
                    labels: vlabels,
                    datasets: [
                        {
                            label: labelValorPlan,
                            backgroundColor: 'rgb(255, 102, 102)', 
                            //borderColor: 'rgb(255, 99, 132)',
                            data: vdatasplan,
                        },
                        {
                            label: labelValorExec,
                            backgroundColor: 'rgb(255, 51, 51)', 
                            //borderColor: 'rgb(255, 99, 132)',
                            data: vdatasexec,
                        }
                    ]
                },

                // Configuration options go here
                options: {
                    scales: {
                        title: {
                            display: true,
                            text: labelTexto
                            },
                        yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelValor
                        },   
                        ticks: {
                            suggestedMin: 0  // minimum will be 0, unless there is a lower value.
                        }
                        }],

                        xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelEtapa
                        }
                        }]
                    }     

                }
            });
        }

    });
}

function montaGrafReceitasEtapasComp(ling){
    var safra = getSafra3();
    var etapasplan = ['preplantioplan', 'plantioplan', 'colheitaplan', 'manutencaosafraplan', 'armazenamentosafraplan', 'comercializacaoplan', 'logrecinsumoplan', 'logentregaarmazplan', 'entregasafracomercplan']
    var etapas = ['preplantio', 'plantio', 'colheita', 'manutencaosafra', 'armazenamentosafra', 'comercializacao', 'logrecinsumo', 'logentregaarmaz', 'entregasafracomerc']


    console.log("Inicio");
    var urlJSON = "/api/servicosetapa/" + safra + "?size=1000";
    
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            tipoetapa = json.map(function(item) {
                return item.tipoetapa;
            });

            valor = json.map(function(item) {
                return item.valorservico;
            });

            fluxo = json.map(function(item) {
                return item.fluxo;
            });

            var vlabels = ['Pre-planting', 'Planting', 'Ingathering', 'Maintenance', 'Storage', 'Commercialization', 'Inputs Receiving', 'Delivery for Storage', 'Delivery for Commercialization'];
            var vdatasplan = [0, 0, 0, 0, 0, 0, 0, 0, 0];
            var vdatasexec = [0, 0, 0, 0, 0, 0, 0, 0, 0];

            var tamanho = tipoetapa.length;

            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'despesa') continue;
                if(etapasplan.indexOf(tipoetapa[i])==-1) continue;

                vdatasplan[etapasplan.indexOf(tipoetapa[i])] += valor[i];
            }


            for(i=0; i<tamanho; i++){

                if(fluxo[i] === 'despesa') continue;
                if(etapas.indexOf(tipoetapa[i])==-1) continue;

                vdatasexec[etapas.indexOf(tipoetapa[i])] += valor[i];
            }

            var ctx = document.getElementById('grafrecetapacomp').getContext('2d');        


            var vlabels; var labelValorPlan; var labelValorExec; var labelTexto; var labelEtapa; var labelValor;
            if(ling === "pt"){
                labelValorPlan = "Valor planejado";
                labelValorExec = "Valor executado";
                labelTexto = "Comparativo de Receita Por Etapa";
                vlabels = ['Pré-plantio', 'Plantio', 'Colheita', 'Manutenção', 'Armazenamento', 'Comercialização', 'Recebimento de Insumos', 'Entrega para Armazenamento', 'Entrega Para Comercialização'];
                labelEtapa = "Etapa";
                labelValor = "Valor";
            }
            else if(ling === "es"){
                labelValorPlan = "Planificado";
                labelValorExec = "Ejecutado";
                labelTexto = "Comparativo del Rendimiento Por Etapa";
                vlabels = ['Pre-siembra', 'Siembra', 'Vendimia', 'Mantenimiento', 'Almacenamiento', 'Comercialización', 'Recebimiento de Consumiveis', 'Entrega para el Almacenamiento', 'Entrega para la Comercialización'];
                labelEtapa = "Etapa";
                labelValor = "Valor";
            }
            else{
                labelValorPlan = "Planned value";
                labelValorExec = "Executed value";
                labelTexto = "Income Comparative By Stage";
                vlabels = ['Pre-planting', 'Planting', 'Ingathering', 'Maintenance', 'Storage', 'Commercialization', 'Inputs Receiving', 'Delivery for Storage', 'Delivery for Commercialization'];
                labelEtapa = "Stage";
                labelValor = "Value";
            }

            var chart = new Chart(ctx, {
                type: 'bar',

                data: {
                    labels: vlabels,
                    datasets: [
                        {
                            label: labelValorPlan,
                            backgroundColor: '#97edbf', 
                            //borderColor: 'rgb(255, 99, 132)',
                            data: vdatasplan,
                        },
                        {
                            label: labelValorExec,
                            backgroundColor: '#61c690', 
                            //borderColor: 'rgb(255, 99, 132)',
                            data: vdatasexec,
                        }
                    ]
                },

                // Configuration options go here
                options: {
                    scales: {
                        title: {
                            display: true,
                            text: labelTexto
                            },
                        yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelValor
                        },   
                        ticks: {
                            suggestedMin: 0  // minimum will be 0, unless there is a lower value.
                        }
                        }],

                        xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: labelEtapa
                        }
                        }]
                    }     

                }
            });
        }
    });
}

function linguagemcomp(){
    var urlJSON = '/api/account/';
    $.ajax({
        url:  urlJSON,
        type: 'GET',
        beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.getItem("jhi-authenticationToken")));
        },
        success: function(json) {
            
            var linguagem = json.langKey;

            if(linguagem==="pt-br"){
            montaRelatorioComp('pt');
            }
            else if(linguagem==="en"){
                montaRelatorioComp('en');
            }
            else{
                montaRelatorioComp('es');
            }
        }
    });
}

function montaRelatorioComp(ling){
    if(ling==='pt'){
        $("#titulodespcomp").html("Comparativo de Despesas ao Longo do tempo");
        $("#tituloreccomp").html("Comparativo de Receita ao Longo do tempo");
        $("#titulodespcompetapa").html("Comparativo de Despesas por Etapas");
        $("#tituloreccompetapa").html("Comparativo de Receita por Etapas");
    }
    else if(ling==='es'){
        $("#titulodespcomp").html("Comparativo de los Gastos a lo largo del tiempo");
        $("#tituloreccomp").html("Comparativo del Rendimiento a lo largo del tiempo");
        $("#titulodespcompetapa").html("Comparativo de los Gastos por Etapas");
        $("#tituloreccompetapa").html("Comparativo del Rendimiento por Etapas");
    }
    else{
        $("#titulodespcomp").html("Output Comparative Over Time");
        $("#tituloreccomp").html("Income Comparative Over Time");
        $("#titulodespcompetapa").html("Output Comparative By Stages");
        $("#tituloreccompetapa").html("Income Comparative By Stages");
    }
    montaGrafDespesasComp(ling);
    montaGrafReceitasComp(ling);
    montaGrafDespesasEtapasComp(ling);
    montaGrafReceitasEtapasComp(ling);
}